import React from 'react';

const TimelineContainer: React.FunctionComponent = ({ children }) => (
  <div className="tc center w-100" style={{ maxWidth: '48rem' }}>
    {children}
  </div>
);

export default TimelineContainer;
